import { render, staticRenderFns } from "./priceInquiry.vue?vue&type=template&id=f21b1dc2&scoped=true&"
import script from "./priceInquiry.vue?vue&type=script&lang=js&"
export * from "./priceInquiry.vue?vue&type=script&lang=js&"
import style0 from "./priceInquiry.vue?vue&type=style&index=0&id=f21b1dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b1dc2",
  null
  
)

export default component.exports